import React from 'react'
import { Node } from './canvas-utils';
import { useQuery } from '@tanstack/react-query';
import { automationsService } from 'services/admin/automationsService';
import { Table, TableRow, TableHead, TableCell, TableBody, Typography } from '@mui/material';
import { toDate } from 'helpers/dateHelper';
import { ActiveTarget } from './AutomationConstructor';

interface NodeStatsDialogProps {
  target: ActiveTarget;
  automationID: number;
}
export const NodeStatsDialog = ({ target, automationID }: NodeStatsDialogProps) => {

  const { data, isLoading, error } = useQuery({
    queryKey: ['node-stats', target?.entityID],
    queryFn: () => automationsService.getNodeStats(automationID, target?.entityID),
  });


  return (
    <div>
      <div className="text-lg">{data?.length > 0 ? `${data?.length} контактов получили сообщение` : "Никто не получил сообщение"}</div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Контакт</TableCell>
            <TableCell>Дата получения</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item: any) => (
            <TableRow key={item.id}>
              {/* Avatar */}
              <TableCell>
                <img src={item.contact?.externalUserPhoto ? item.contact?.externalUserPhoto : "/media/images/avatar_f.jpg"}
                  alt={item.contact?.externalUserUserName}
                  className="w-10 h-10 rounded-full"
                  onError={(e) => {
                    e.currentTarget.src = "/media/images/avatar_f.jpg";
                  }}
                />
              </TableCell>
              <TableCell>{item.contact.externalUserUserName || item.contact.externalUserID}</TableCell>
              <TableCell>{toDate(item.createdAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
